import { render, staticRenderFns } from "./AIWriter.vue?vue&type=template&id=20846f0a&"
import script from "./AIWriter.vue?vue&type=script&lang=ts&"
export * from "./AIWriter.vue?vue&type=script&lang=ts&"
import style0 from "./AIWriter.vue?vue&type=style&index=0&id=20846f0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports